<template>

  <div>
    <b-container v-if="!showMap" class="mt-4">

      <!-- placeholder tant qu'il n'y a pas de recherche faite (normalement jamais) / chargement -->
      <transition-group v-if="currentOffset === null" appear name="listCustomTransition" tag="div">
        <div key="searchPlaceHolder-nbAnnonces" :class="{'placeholder-animated': isSearching}"
             class="card-nb-annonces placeholder-nb-annonces">
        </div>
        <div key="searchPlaceHolder-cardAnnonces" class="row row-cards-annonces">
          <!-- 1 ligne background plain / animated if searching -->
          <PlaceholderCardAnnonce :isAnimated=isSearching :isGradient=false></PlaceholderCardAnnonce>
          <PlaceholderCardAnnonce :isAnimated=isSearching :isGradient=false
                                  customDisplayClass="d-none d-sm-none d-md-block"></PlaceholderCardAnnonce>
          <PlaceholderCardAnnonce :isAnimated=isSearching :isGradient=false
                                  customDisplayClass="d-none d-sm-none d-md-none d-lg-block"></PlaceholderCardAnnonce>

          <!-- 1 ligne background dégradé / animated if searching -->
          <PlaceholderCardAnnonce :isAnimated=isSearching :isGradient=true></PlaceholderCardAnnonce>
          <PlaceholderCardAnnonce :isAnimated=isSearching :isGradient=true
                                  customDisplayClass="d-none d-sm-none d-md-block"></PlaceholderCardAnnonce>
          <PlaceholderCardAnnonce :isAnimated=isSearching :isGradient=true
                                  customDisplayClass="d-none d-sm-none d-md-none d-lg-block"></PlaceholderCardAnnonce>
        </div>
      </transition-group>
      <!-- result d'une recherche -->
      <div v-else>


        <div class="d-flex justify-content-between  align-items-center">
          <div class="d-flex align-items-center ">
            <b-button v-if="canCreateSavedSearch && !savedSearchId"
                      class="mr-3  btn-create-saved-search d-flex align-items-center"
                      @click="createSavedSearch">
              <div>{{ $t('saved.search.a.create') }}</div>
              <i class="ph-custom ph-megaphone align-items-center ml-2"></i>
            </b-button>
            <b-button v-if="canCreateSavedSearch && savedSearchId"
                      id="btn-delete-saved-search-id"
                      class="mr-3 btn-delete-saved-search d-flex align-items-center"
                      variant="btn-delete-saved-search"
                      @click="deleteSavedSearch">
              <div>{{ $t('saved.search.delete') }}</div>
              <i class="ph-custom ph-megaphone align-items-center ml-2"></i>
            </b-button>
            <i v-if="canCreateSavedSearch" class="ph-custom ph-question mr-2 ph-custom-question"
               @click="$bvModal.show('alert-info-modal')"></i>
            <div v-if="totalRows > 0" class="card-nb-annonces h-100">
              {{ totalRows }} {{ totalRows > 1 ? $t('Annonces') : $t('Annonce') }}
            </div>
          </div>
          <div v-if="totalRows > 0" class="sort-button" @click="openFiltersModal('sort')">
            <i class="ph-custom ph-arrows-down-up"/>
          </div>
        </div>
        <div class="row row-cards-annonces">
          <!-- avec des annonces -->
          <template v-if="annonces && annonces.length > 0">
            <transition-group v-for="annonce in annonces" :key="annonce.serverId+'annonceCard'" appear
                              class="col-container-card-annonce col-12 col-sm-12 col-md-6 col-lg-4"
                              name="listCustomTransition"
                              tag="div">
              <annonce-card-image-left :key="annonce.serverId" :annonce="annonce" class="cursor-pointer"/>
            </transition-group>

            <div v-if="nextOffset > 0" class="col-12 d-flex justify-content-center">
              <div v-if="!isSearching" class="see-more-button btn-primary" @click="addMoreAnnonces">
                {{ isSearching ? '...' : $t('annonce.search.see.more') }}
              </div>
              <div v-if="isSearching" class="see-more-button-searching">
                ...
              </div>
            </div>
          </template>
          <!-- aucune annonce -->
          <transition-group v-else appear class="col-12 empty-state-container" name="listCustomTransition" tag="div">
            <div key="searchEmptyState-img" class="text-center mb-4">
              <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result" class="empty-state-img">
            </div>
            <div key="searchEmptyState-txt" class=" text-center no-result-text">
              <div class="no-result-title mb-2">{{ $t('annonce.search.emptyTitle') }}</div>
              <div class="no-result-subtitle my-2">{{ $t('annonce.search.emptyText') }}</div>
            </div>
          </transition-group>

        </div>
      </div>

      <!--  region display map button    -->
      <div class="row justify-content-center">
        <div
          v-if="currentOffset !== null"
          id="mapButton"
          class="bold-text cursor-pointer"
          v-on:click="showMap = true"
        >
          {{ $t('annonce.search.display.map') }}
          <i class="ph-custom ph-map-trifold-bold ml-2"></i>
        </div>
      </div>
      <!--  endregion    -->

    </b-container>

    <AnnoncesMap
      v-if="showMap"
      :annonces="annonces"
      :user="user"
      class="annonces-map-div"
      @hideMap="showMap = false"
      @searchFromCenterOfMap="searchAnnoncesFromCenterOfMap"
    />

    <filters-modal
      v-if="filtersDataInitialValuesIsReady"
      :filtersDataInitial="filtersDataInitialValues"
      :fromBtnName="fromBtnName"
      :needsToGetFiltersDataFromApp="needsToGetFiltersDataFromApp"
    ></filters-modal>

    <create-saved-search-modal
      v-if="canCreateSavedSearch"
      :filters-data="{
        researchText: this.researchText,
        address: this.address,
        researchSorting: this.researchSorting,
        locationRadius: this.locationRadius,
        latitude: this.latitude,
        longitude: this.longitude,
        vehicles: this.vehicles,
        brands: this.brands,
        models: this.models,
        modelFinishes: this.modelFinishes,
        colors: this.colors,
        energies: this.energies,
        minFiscalPower: this.minFiscalPower,
        maxFiscalPower: this.maxFiscalPower
    }"
      @saved-search-created="savedSearchCreated">
    </create-saved-search-modal>

    <delete-saved-search-modal v-if="savedSearchId" :selected-item="savedSearchId" :selected-item-name="savedSearchName"
                               begins-with-voyel
                               item-to-string="alerte"
                               the-article="l'"
                               @didDeleteItem="didDeleteAlert"></delete-saved-search-modal>

    <alert-info-modal></alert-info-modal>


  </div>

</template>

<script>

import api from '../../services/api'
import {eventBus} from "../../main"
import AnnonceCardImageLeft from "../../components/annonce/AnnonceCardImageLeft"
import PlaceholderCardAnnonce from "./PlaceholderCardAnnonce"
import FiltersModal from "./FiltersModal"
import AnnoncesMap from "./AnnoncesMap"
import CreateSavedSearchModal from "./CreateSavedSearchModal"
import DeleteSavedSearchModal from "./DeleteSavedSearchModal"
import AlertInfoModal from "./AlertInfoModal"

export default {
  name: 'Search',

  components: {
    AnnonceCardImageLeft,
    PlaceholderCardAnnonce,
    FiltersModal,
    AnnoncesMap,
    CreateSavedSearchModal,
    DeleteSavedSearchModal,
    AlertInfoModal
  },

  data() {
    return {
      showMap: false,

      user: {
        lat: null,
        lng: null,
      },

      fromBtnName: null,

      isSearching: false,

      totalRows: 0,
      annonces: [],
      currentOffset: null,
      nextOffset: 0,

      researchSorting: null,
      researchText: this.$route.params.search,

      //from filters
      address: null,

      //filters values
      locationRadius: null,
      latitude: null,
      longitude: null,
      vehicles: null,
      brands: null,
      models: null,
      modelFinishes: null,
      colors: null,
      energies: null,
      minFiscalPower: null,
      maxFiscalPower: null,

      filtersDataInitialValuesIsReady: false,
      filtersDataInitialValues: null,
      needsToGetFiltersDataFromApp: false,

      savedSearchId: null,
      savedSearchName: null,
    }
  },

  async created() {
    eventBus.$on('openFiltersModal', this.openFiltersModal)
    eventBus.$on('searchAnnoncesFromText', this.searchAnnoncesFromText)
    eventBus.$on('searchAnnoncesFromNewFilters', this.searchAnnoncesFromNewFilters)
    eventBus.$on('getSearchInputFromApp', this.getSearchInputFromApp)
    eventBus.$on('getSearchInputFromAppWithUpdateResults', this.getSearchInputFromAppWithUpdateResults)
    eventBus.$on('searchWithoutFiltersData', this.searchWithoutFiltersData)
  },

  destroyed() {
    eventBus.$off('openFiltersModal', this.openFiltersModal)
    eventBus.$off('searchAnnoncesFromText', this.searchAnnoncesFromText)
    eventBus.$off('searchAnnoncesFromNewFilters', this.searchAnnoncesFromNewFilters)
    eventBus.$off('getSearchInputFromApp', this.getSearchInputFromApp)
    eventBus.$off('getSearchInputFromAppWithUpdateResults', this.getSearchInputFromAppWithUpdateResults)
    eventBus.$off('searchWithoutFiltersData', this.searchWithoutFiltersData)
  },

  async mounted() {
    await this.fetchData()

    //filtersDataInitialValues
    if (this.$route.params.annonceType) {
      eventBus.$emit("resetFiltersValues")

      if (this.$route.params.annonceType === 'CLOSE_ANNONCES') {
        await this.setInitialResearchSortingValue("PROXIMITY")

      } else if (this.$route.params.annonceType === 'LAST_ANNONCES') {
        await this.setInitialResearchSortingValue("MOST_RECENT")

      } else if (this.$route.params.annonceType === 'SAVED_SEARCH_ANNONCES') {
        if (this.$route.params.savedSearchId) {
          this.savedSearchId = Number(this.$route.params.savedSearchId)
          this.savedSearchName = this.$route.params.savedSearchName
          await this.setInitialSavedSearchValues(this.$route.params.savedSearchId)
        }

      } else if (this.$route.params.annonceType === 'VEHICLE_ANNONCES') {
        await this.setInitialVehicleTypeValue(this.$route.params.vehicleTypeId)
      }
    }
    if (this.$route.params.filtersData) {
      this.filtersDataInitialValues = this.$route.params.filtersData
    }

    //update filtersData infos in Search.vue if filtersDataInitialValues
    var withUpdateFiltersValues = false
    if (this.filtersDataInitialValues) {
      this.researchSorting = this.filtersDataInitialValues.researchSorting
      this.address = this.filtersDataInitialValues.address
      this.locationRadius = this.filtersDataInitialValues.locationRadius
      this.latitude = this.filtersDataInitialValues.latitude
      this.longitude = this.filtersDataInitialValues.longitude
      this.vehicles = this.filtersDataInitialValues.vehicles
      this.brands = this.filtersDataInitialValues.brands
      this.models = this.filtersDataInitialValues.models
      this.modelFinishes = this.filtersDataInitialValues.modelFinishes
      this.colors = this.filtersDataInitialValues.colors
      this.energies = this.filtersDataInitialValues.energies
      this.minFiscalPower = this.filtersDataInitialValues.minFiscalPower
      this.maxFiscalPower = this.filtersDataInitialValues.maxFiscalPower

      withUpdateFiltersValues = true
    }

    //modal
    if (this.$route.params.fromBtnName) {
      await this.openFiltersModal(this.$route.params.fromBtnName, true)
    }

    //recherche
    if (this.$route.params.search) {
      await this.searchAnnoncesFromText(this.$route.params.search)

    } else if (this.filtersDataInitialValues || this.$route.params.fromBtnName) {
      //on veut avoir une première recherche appliquée uniquement si on connait deja les filtres initiaux ou si on a cliqué sur un btn filtre qui ouvre la modale
      //dans les autres cas d'arrivée sur search.vue:
      //- avec un texte de recherche => searchAnnoncesFromText
      //- avec un retour où on ira récupérer filtersData dans App.vue => la recherche sera faite en suivant
      await this.refreshAnnonces(withUpdateFiltersValues, this.filtersDataInitialValues)
    }

    this.needsToGetFiltersDataFromApp = !this.filtersDataInitialValues && !this.$route.params.search && !this.$route.params.fromBtnName

    this.filtersDataInitialValuesIsReady = true
  },

  computed: {
    canCreateSavedSearch() {

      const hasTextOrLocation = Boolean(this.researchText && this.researchText.trim() !== "") || Boolean(this.locationRadius) || Boolean(this.latitude) || Boolean(this.longitude);

      const vehiclesArray = typeof this.vehicles === 'string' ? JSON.parse(this.vehicles) : this.vehicles;
      const brandsArray = typeof this.brands === 'string' ? JSON.parse(this.brands) : this.brands;
      const modelsArray = typeof this.models === 'string' ? JSON.parse(this.models) : this.models;
      const modelFinishesArray = typeof this.modelFinishes === 'string' ? JSON.parse(this.modelFinishes) : this.modelFinishes;
      const colorsArray = typeof this.colors === 'string' ? JSON.parse(this.colors) : this.colors;
      const energiesArray = typeof this.energies === 'string' ? JSON.parse(this.energies) : this.energies;

      const hasValidVehicles = Array.isArray(vehiclesArray) && vehiclesArray.length > 0;
      const hasValidBrands = Array.isArray(brandsArray) && brandsArray.length > 0;
      const hasValidModels = Array.isArray(modelsArray) && modelsArray.length > 0;
      const hasValidModelFinishes = Array.isArray(modelFinishesArray) && modelFinishesArray.length > 0;
      const hasValidColors = Array.isArray(colorsArray) && colorsArray.length > 0;
      const hasValidEnergies = Array.isArray(energiesArray) && energiesArray.length > 0;

      const hasFiscalPower = (this.minFiscalPower !== null && this.minFiscalPower !== undefined && this.minFiscalPower !== 0) || (this.maxFiscalPower !== null && this.maxFiscalPower !== undefined && this.maxFiscalPower !== 0);

      return hasTextOrLocation || hasValidVehicles || hasValidBrands || hasValidModels || hasValidModelFinishes || hasValidColors || hasValidEnergies || hasFiscalPower;
    }


  },
  methods: {

    didDeleteAlert() {
      this.savedSearchId = null
      this.savedSearchName = null
    },

    savedSearchCreated(id, name) {
      this.savedSearchId = id
      this.savedSearchName = name
    },

    async fetchData() {
      await this.getPositionUser()
    },

    createSavedSearch() {
      this.$bvModal.show('create-saved-search-modal')
    },
    deleteSavedSearch() {
      this.$bvModal.show('delete-saved-search-modal')
    },


    getPositionUser() {
      return new Promise((resolve) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.setPosition(position)
            resolve()
          }, (error) => {
            console.error("Error getting position:", error)
            resolve() // Résoudre la promesse même en cas d'erreur
          });
        } else {
          console.error("Geolocation is not supported by this browser.")
          resolve() // Résoudre la promesse si la géolocalisation n'est pas supportée
        }
      });
    },

    setPosition(position) {
      this.user.lat = position.coords.latitude
      this.user.lng = position.coords.longitude
    },

    openFiltersModal(fromBtnName, fromMounted = false) {
      if (fromBtnName !== this.fromBtnName) {
        this.fromBtnName = fromBtnName
      } else {
        eventBus.$emit("openFiltersModalFromSameFromBtnName")
      }
      if (!fromMounted) {
        this.showFiltersModal()
      }
    },

    showFiltersModal() {
      this.$bvModal.show('filters-modal')
    },

    setInitialResearchSortingValue(researchSorting) {
      this.initEmptyFiltersDataInitialValues(researchSorting, null)
    },

    setInitialVehicleTypeValue(vehicleTypeId) {
      this.initEmptyFiltersDataInitialValues(null, this.toStringApiList([vehicleTypeId]))
    },

    async setInitialSavedSearchValues(savedSearchId) {
      let formData = new FormData()
      formData.append('savedSearchId', savedSearchId)

      await api({
        method: 'POST',
        url: '/search/getFiltersDataInitialValuesFromSavedSearch',
        data: formData
      }).then(async (response) => {
        if (response.data === "") {
          this.filtersDataInitialValues = null
        } else {
          this.filtersDataInitialValues = response.data

          //+ set null values
          if (response.data.address === undefined) {
            this.filtersDataInitialValues.address = null
          }
          if (response.data.locationRadius === undefined) {
            this.filtersDataInitialValues.locationRadius = null
          }
          if (response.data.latitude === undefined) {
            this.filtersDataInitialValues.latitude = null
          }
          if (response.data.longitude === undefined) {
            this.filtersDataInitialValues.longitude = null
          }
          if (response.data.maxFiscalPower === undefined) {
            this.filtersDataInitialValues.maxFiscalPower = null
          }
          if (response.data.selectedFilterVehicleTypeNameIfOne === undefined) {
            this.filtersDataInitialValues.selectedFilterVehicleTypeNameIfOne = null
          }
          if (response.data.selectedFilterBrandNameIfOne === undefined) {
            this.filtersDataInitialValues.selectedFilterBrandNameIfOne = null
          }
        }
      })
    },

    initEmptyFiltersDataInitialValues(researchSorting, vehicles) {
      console.log("initEmptyFiltersDataInitialValues")
      var emptyList = this.toStringApiList([])
      this.filtersDataInitialValues = {
        researchSorting: researchSorting,
        address: null,
        locationRadius: null,
        latitude: null,
        longitude: null,
        vehicles: vehicles ? vehicles : emptyList,
        brands: emptyList,
        models: emptyList,
        modelFinishes: emptyList,
        colors: emptyList,
        energies: emptyList,
        modelsHigherCategoryIds: emptyList,
        modelFinishesHigherCategoryIds: emptyList,
        minFiscalPower: 0,
        maxFiscalPower: null,
        isSelectedFiscalPowerFilter: false,
        selectedFilterVehicleTypeNameIfOne: null,
        selectedFilterBrandNameIfOne: null,
      }
    },

    getSearchInputFromApp(search) {
      this.researchText = search
    },

    async getSearchInputFromAppWithUpdateResults(search) {
      this.searchAnnoncesFromText(search)
    },

    searchAnnoncesFromText(researchText) {
      this.researchText = researchText
      this.refreshAnnonces(false)
      this.checkForExistingSavedSearch()
    },

    searchAnnoncesFromNewFilters(filtersData) {
      //update filters
      this.researchSorting = filtersData.researchSorting
      this.locationRadius = filtersData.locationRadius
      this.latitude = filtersData.latitude
      this.longitude = filtersData.longitude
      this.vehicles = filtersData.vehicles
      this.brands = filtersData.brands
      this.models = filtersData.models
      this.modelFinishes = filtersData.modelFinishes
      this.colors = filtersData.colors
      this.energies = filtersData.energies
      this.minFiscalPower = filtersData.minFiscalPower
      this.maxFiscalPower = filtersData.maxFiscalPower

      this.refreshAnnonces(true, filtersData)
      this.checkForExistingSavedSearch()
    },

    async checkForExistingSavedSearch() {
      const formData = new FormData();
      if (this.researchText && this.researchText.trim() !== "") {
        formData.append('researchText', this.researchText);
      }
      if (this.address) {
        formData.append('address', this.address);
      }
      if (this.locationRadius) {
        formData.append('locationRadius', this.locationRadius);
      }
      if (this.latitude) {
        formData.append('latitude', this.latitude);
      }
      if (this.longitude) {
        formData.append('longitude', this.longitude);
      }

      if (this.vehicles) {
        formData.append('vehicles', this.vehicles);
      }
      if (this.brands) {
        formData.append('brands', this.brands);
      }
      if (this.models) {
        formData.append('models', this.models);
      }
      if (this.modelFinishes) {
        formData.append('modelFinishes', this.modelFinishes);
      }
      if (this.colors) {
        formData.append('colors', this.colors);
      }
      if (this.energies) {
        formData.append('energies', this.energies);
      }
      if (this.minFiscalPower) {
        formData.append('minFiscalPower', this.minFiscalPower);
      }
      if (this.maxFiscalPower) {
        formData.append('maxFiscalPower', this.maxFiscalPower);
      }

      try {
        const response = await api({
          method: 'POST',
          url: '/savedSearch/checkExisting',
          data: formData,
        });
        this.savedSearchId = response.data.savedSearchId;
        this.savedSearchName = response.data.savedSearchName;
      } catch (error) {
        console.error("Error checking for existing SavedSearch:", error);
      }
    },


    searchAnnoncesFromCenterOfMap(center) {
      this.researchSorting = 'PROXIMITY'
      this.locationRadius = 200
      this.latitude = center.lat
      this.longitude = center.lng

      this.refreshAnnonces(true, {
        researchSorting: 'PROXIMITY',
        address: null,
        locationRadius: 200,
        latitude: center.lat,
        longitude: center.lng,
        vehicles: this.vehicles,
        brands: this.brands,
        models: this.models,
        modelFinishes: this.modelFinishes,
        colors: this.colors,
        energies: this.energies,
        minFiscalPower: this.minFiscalPower,
        maxFiscalPower: this.maxFiscalPower,
      })
    },

    searchWithoutFiltersData() {
      this.refreshAnnonces(false)
    },

    refreshAnnonces(withUpdateFiltersValues, filtersData = {}) {
      this.isSearching = true

      this.annonces = []
      this.currentOffset = null
      this.nextOffset = 0
      if (filtersData && filtersData.hasOwnProperty('address')) {
        this.address = filtersData.address
      }
      this.getNewAnnonces(withUpdateFiltersValues, filtersData)
    },

    addMoreAnnonces() {
      this.isSearching = true
      this.getNewAnnonces(false)
    },

    getNewAnnonces(withUpdateFiltersValues, filtersData = {}) {
      if (this.nextOffset == null) {
        console.log("this.nextOffset == null")
        return
      }

      var isForFirstResult = this.nextOffset === 0

      //il ne faut pas envoyer les "null"
      let formData = new FormData()
      formData.append('offset', this.nextOffset)

      if (this.researchSorting) {
        formData.append('researchSorting', this.researchSorting)
      }
      if (this.user.lat !== null && this.user.lng !== null) {
        formData.append('userLatitude', this.user.lat)
        formData.append('userLongitude', this.user.lng)
      }
      if (this.researchText) {
        formData.append('researchText', this.researchText)
      }
      if (this.locationRadius) {
        formData.append('locationRadius', this.locationRadius)
      }
      if (this.latitude != null) {
        formData.append('latitude', this.latitude)
      }
      if (this.longitude != null) {
        formData.append('longitude', this.longitude)
      }
      if (this.vehicles) {
        formData.append('vehicleTypeIds', this.vehicles)
      }
      if (this.brands) {
        formData.append('brandIds', this.brands)
      }
      if (this.models) {
        formData.append('modelIds', this.models)
      }
      if (this.modelFinishes) {
        formData.append('modelFinishIds', this.modelFinishes)
      }
      if (this.colors) {
        formData.append('colors', this.colors)
      }
      if (this.energies) {
        formData.append('energies', this.energies)
      }
      if (this.minFiscalPower != null) {
        formData.append('minFiscalPower', this.minFiscalPower)
      }
      if (this.maxFiscalPower != null) {
        formData.append('maxFiscalPower', this.maxFiscalPower)
      }

      api({
        method: 'POST',
        url: '/search/getSearchAnnonces',
        data: formData
      }).then((response) => {

        var nbResAnnonces = 0

        //annonces
        if (response.data.annonces) {
          nbResAnnonces = response.data.annonces.length

          if (isForFirstResult) {
            this.annonces = response.data.annonces
          } else {
            response.data.annonces.forEach(annonce => {
              this.annonces.push(annonce)
            })
          }
        }

        //offset
        this.currentOffset = this.nextOffset
        if (response.data.isEndOfData) {
          this.nextOffset = null
        } else {
          this.nextOffset = this.currentOffset + nbResAnnonces
        }

        //total
        this.totalRows = response.data.totalNbAnnonces

        //filters
        if (withUpdateFiltersValues) {
          eventBus.$emit("updateFiltersValues", filtersData)
        }

        //end
        this.isSearching = false
      })
    },

    toStringApiList(list) {
      return JSON.stringify(list)
    },

  },
}

</script>

<style scoped>

.row-cards-annonces {
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  margin-left: -1rem;
}

.card-nb-annonces {
  height: 35px;
}

.col-container-card-annonce {
  padding-left: 1rem;
  padding-bottom: 1rem;
  padding-right: 0px;
}

.row-cards-annonces .last-annonce-card {
  height: 100%;
}

.placeholder-nb-annonces {
  width: 150px;
  border-radius: var(--secondary-border-radius);
  background-color: var(--main-black-medium);
}

.placeholder-animated {
  background: var(--linear-gradient-main-black-medium-animated);
  background-size: 400% 400%;

  animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
  -webkit-animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
  -moz-animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
}

.sort-button {
  cursor: pointer;
  margin-right: 8px;
}

.sort-button:hover {
  color: var(--main-yellow-medium);
}

.see-more-button {
  cursor: pointer;
  font-weight: bold;
  border-radius: var(--secondary-border-radius);
  margin-bottom: 30px;
}

.see-more-button-searching {
  color: var(--main-yellow-medium);
  font-weight: bold;
  margin-bottom: 50px;
}


/*region map*/
#mapButton {
  z-index: 3;
  position: fixed;
  bottom: 30px;
  /*left: 50%;*/
  padding: 10px;
  border-radius: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--main-yellow-medium);
  color: var(--main-black-light);
}

#mapButton:hover {
  background-color: var(--main-yellow-dark);
}

.annonces-map-div {
  position: fixed;
  width: 100vw;
  height: 91%;
  left: 0;
  z-index: 1;
}

.btn-create-saved-search {
  background-color: transparent !important;
  border-color: var(--main-white) !important;
  color: var(--main-white) !important;
  padding: 7px 16px;
  border-radius: var(--third-border-radius);
  font-size: var(--mediumer-font-size);
  font-family: "KumbhSans-Regular", "Arial", sans-serif;
}

#btn-delete-saved-search-id {
  background-color: transparent !important;
  border-color: var(--main-red-medium) !important;
  color: var(--main-red-medium) !important;
  padding: 7px 16px;
  border-radius: var(--third-border-radius);
  font-size: var(--mediumer-font-size);
  font-family: "KumbhSans-Regular", "Arial", sans-serif;
}

#btn-delete-saved-search-id:hover {
  background-color: var(--main-black-dark) !important;
  border-color: var(--main-red-medium) !important;
  color: var(--main-red-medium) !important;
}

.ph-custom-question {
  font-size: 30px;
  color: var(--main-grey-medium);
  cursor: pointer;
}


/*endregion*/

</style>



// WEBPACK FOOTER //
// src/views/search/Search.vue